import CommandsService from '@/api/services/commands.service'
import IPosition from '@/models/dto/position.dto'
import { ActionType } from '@/models/enum-types/action-type.enum'
import IDeviceStore from '@/models/modelStore/IDeviceStore'
import IDataInfo from '@/models/modelView/IDataInfo'
import DeviceViewData from '@/models/modelView/IDeviceView'
import DeviceUtil from '@/utils/device.util'
import { ModemStrategy } from './modem.strategy'

export default class QbitStrategy extends ModemStrategy {
    getExtraAttributes(attributes: any): IDataInfo[] {
        return [{ title: 'Odo:', value: (attributes.totalDistance / 1000).toFixed(2) + 'Km' }]
    }

    getReportDetails(data: IPosition[], device: IDeviceStore) {
        return this.genericReportDetails(data, device)
    }

    customAttributes: any[] = [{ name: 'sat', viewName: 'Satelites:', suffix: '' }]

    async sendCommand(deviceId: number, type: ActionType, data?: string) {
        let command = ''
        switch (type) {
            case ActionType.RESET:
                command = 'RESET#'
                break
            default:
                break
        }
        await CommandsService.sendCommand(command, deviceId)
        await CommandsService.sendCommand('GPSON,20#', deviceId)
    }

    mapDevice(device: IDeviceStore): DeviceViewData {
        return {
            data_icons: this.mapIcons(device),
            data_info: this.mapAttributes(device.position?.attributes, device),
            icon: device.icon || '0',
            id: device.id,
            plate: device.name,
            time: device.position?.deviceTime || device.position?.serverTime || device.position?.fixTime || '',
            speed: DeviceUtil.formatKnToKmh(device.position?.speed),
        }
    }

    mapIcons(device: IDeviceStore) {
        const array = [
            {
                classes: ['icon-data', 'battery-gps'],
                src: require('@/assets/img/battery-gps.svg'),
                extra: (this.getBatteryPercentage(device.position?.attributes?.battery) || '-') + '%',
            },
        ]

        if (device.position?.attributes?.charge)
            array.push({
                classes: ['icon-data', 'charge'],
                src: require('@/assets/img/charge.svg'),
                extra: '',
            })
        return array
    }

    getPercent(battery: number) {
        return (117.65 * battery - 409.41).toFixed(0)
    }

    getBatteryPercentage(voltage: number): number {
        if (voltage >= 4.08) return 100
        if (voltage >= 3.9) return 80
        if (voltage >= 3.78) return 60
        if (voltage >= 3.7) return 40
        if (voltage >= 3.64) return 20
        if (voltage >= 3.59) return 5
        if (voltage >= 3.58) return 1
        return 0
    }
}
